/**
 * Утилиты для номера телефона: Россия, код +7, далее 10 цифр.
 */

const COUNTRY_CODE = '7';

/** Из строки оставляем только цифры */
export function digitsOnly(value: string): string {
  return (value || '').replace(/\D/g, '');
}

/**
 * Нормализует ввод к формату хранения: +7XXXXXXXXXX (11 символов).
 * Если пользователь ввёл 10 цифр — добавляем 7; если 11 и первая 7/8 — приводим к +7 + 10 цифр.
 */
export function normalizePhone(value: string): string {
  const d = digitsOnly(value);
  if (d.length === 0) return '';
  let ten = d;
  if (d.length >= 11 && (d[0] === '7' || d[0] === '8')) {
    ten = d.slice(1, 11);
  } else if (d.length > 10) {
    ten = d.slice(0, 10);
  } else if (d.length <= 10) {
    ten = d.slice(0, 10);
  }
  return ten.length === 0 ? '' : `+${COUNTRY_CODE}${ten}`;
}

/**
 * Проверка: ровно 10 цифр после +7 (нормализованная строка или сырой ввод).
 */
export function isValidRussianPhone(value: string): boolean {
  const normalized = normalizePhone(value || '');
  const d = digitsOnly(normalized);
  return d.length === 11 && d[0] === '7' && d.slice(1).length === 10;
}

/** Сообщение: поле пустое */
export const PHONE_REQUIRED_MESSAGE = 'Введите номер телефона';
/** Сообщение: не ровно 10 цифр */
export const PHONE_VALIDATION_MESSAGE = 'Введите ровно 10 цифр номера после +7 (например: 912 345-67-89)';

/**
 * Форматирование для отображения: +7 (XXX) XXX-XX-XX
 */
export function formatPhoneDisplay(phone: string): string {
  const d = digitsOnly(phone);
  if (d.length === 0) return '';
  const ten = d.length >= 11 && (d[0] === '7' || d[0] === '8') ? d.slice(1, 11) : d.slice(0, 10);
  if (ten.length === 0) return '';
  const a = ten.slice(0, 3);
  const b = ten.slice(3, 6);
  const c = ten.slice(6, 8);
  const e = ten.slice(8, 10);
  return `+7 (${a}) ${b}-${c}-${e}`;
}

/**
 * Из значения формы (+79… или +79123456789) извлекаем 10 цифр для отображения в поле (без ведущей 7/8).
 */
export function getTenDigitsForInput(phone: string): string {
  const d = digitsOnly(phone);
  if (!d.length) return '';
  if (d[0] === '7' || d[0] === '8') return d.slice(1, 11);
  return d.slice(0, 10);
}

/** Количество цифр номера после +7 (0–10). Для валидации «ровно 10». */
export function getPhoneDigitCount(value: string): number {
  return getTenDigitsForInput(value || '').length;
}

/**
 * Формат 10 цифр для отображения в поле с addon "+7": только введённые цифры, форматирование по мере набора.
 * 1–3 цифры: как есть; с 4-й: " (XXX) ..."; с 7-й: "...-XX-..."
 */
export function formatPhoneInputDisplay(tenDigits: string): string {
  if (!tenDigits || tenDigits.length === 0) return '';
  const d = tenDigits.slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return ` (${d.slice(0, 3)}) ${d.slice(3)}`;
  if (d.length <= 8) return ` (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  return ` (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 8)}-${d.slice(8, 10)}`;
}
